const ICON_BASE_URL = 'https://storage.googleapis.com/public-score-icons/'

export function getIconUrlFromGCP(name: string) {
  return ICON_BASE_URL + (name?.split('.')[0] || 'arcx') + '.png'
}
